// extracted by mini-css-extract-plugin
export var button = "ContentBlock-module--button--072ad";
export var headerForm = "ContentBlock-module--headerForm--a08be";
export var heroFeatures = "ContentBlock-module--heroFeatures--a4796";
export var isNotFluid = "ContentBlock-module--isNotFluid--2669d";
export var linkText = "ContentBlock-module--linkText--5aa26";
export var links = "ContentBlock-module--links--079ab";
export var richtextButton = "ContentBlock-module--richtextButton--aeae3";
export var root = "ContentBlock-module--root--4a680";
export var v2 = "ContentBlock-module--v2--fd6ab";